import { Navigate, useParams } from "react-router";

import { navigation } from "@src/shared/navigation";

export default function PatientIndexRedirect() {
  const { patientId } = useParams();

  if (!patientId) {
    return null;
  }

  return <Navigate to={navigation.patientBriefing(patientId)} replace />;
}
